import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ajukanJurnalHarian, updateJurnalHarian } from "../services/jurnalHarianService";
import BottomNavbar from "../components/BottomNavbar";
import logo from "../assets/EPRAJOGO1.png";

function InputJurnalHarian() {
  const navigate = useNavigate();
  const location = useLocation();
  const journal = location.state?.journal;
  const [tanggal, setTanggal] = useState(journal?.tanggal?.slice(0, 10) || "");
  const [pekerjaan, setPekerjaan] = useState(journal?.pekerjaan || "");
  const [catatan, setCatatan] = useState(journal?.catatan || "");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const siswaId = localStorage.getItem("user_id");

    setLoading(true);
    const result = journal
      ? await updateJurnalHarian(journal.id, { tanggal, pekerjaan, catatan, siswa_id: siswaId })
      : await ajukanJurnalHarian({ tanggal, pekerjaan, catatan, siswa_id: siswaId });
    setLoading(false);

    if (result.success) {
      alert(result.message || (journal ? "Jurnal berhasil diperbaiki dan dikirim ulang." : "Jurnal berhasil disimpan!"));
      navigate("/jurnal-harian");
    } else {
      alert(result.message || "Gagal menyimpan jurnal harian");
    }
  };

  return (
    <main className="app-mobile-page">
      <header className="app-brand-header">
        <div className="app-brand-row">
          <img src={logo} alt="Logo E-Prajogo" className="app-brand-logo" />
          <div><p className="app-brand-name">E-PRAJOGO</p><p className="app-brand-school">SMK NEGERI GUDO</p></div>
          <span className="ms-auto rounded-pill px-3 py-2 small fw-semibold" style={{ background: "#ffffff20", color: "#fff" }}>SISWA</span>
        </div>
        <h1 className="app-header-title">{journal ? "Perbaiki Jurnal Harian" : "Input Jurnal Harian"}</h1>
        <p className="app-header-subtitle">Tuliskan kegiatan PKL yang kamu lakukan hari ini.</p>
      </header>

      <section className="app-content">
      <form className="journal-form-card" onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label fw-bold">Tanggal</label>
          <input
            type="date"
            className="form-control"
            value={tanggal}
            onChange={(e) => setTanggal(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Pekerjaan</label>
          <input
            type="text"
            className="form-control"
            placeholder="Masukkan pekerjaan hari ini"
            value={pekerjaan}
            onChange={(e) => setPekerjaan(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Catatan</label>
          <textarea
            className="form-control"
            rows="3"
            placeholder="Masukkan catatan tambahan"
            value={catatan}
            onChange={(e) => setCatatan(e.target.value)}
          />
        </div>

        <button type="submit" className="btn btn-primary w-100">
          {loading ? <><span className="spinner-border spinner-border-sm me-2" />Mengirim...</> : <><i className="bi bi-save me-2"></i>{journal ? "Kirim Ulang untuk Verifikasi" : "Simpan"}</>}
        </button>
      </form>
      </section>
      <BottomNavbar />
    </main>
  );
}

export default InputJurnalHarian;
